﻿(function () {
  if (document.querySelector('.header-carousel')) {
    var slider = tns({
      container: '.header-carousel',
      controls: false,
      autoplay: true,
      nav: false,
      gutter: 0,
      autoplayButtonOutput: false,
      speed: 900,
      autoplayHoverPause: true,
      items: 1,
      useLocalStorage: false,
      onInit: function () {
        document.getElementsByClassName("header-carousel")[0].classList.add("init");
      },
      slideBy: 1,
      autoplayTimeout: 3000,
      responsive: {
        576: {
          items: 2,
          slideBy: 2,
          autoplayTimeout: 4000
        },
        992: {
          items: 3,
          slideBy: 3,
          autoplayTimeout: 5000
        }
      }
    });
  }
})();

